/**
 * AUTO-GENERATED SUBSTANCE CATALOG
 * 
 * Generated by: scripts/generateSubstanceCatalog.js
 * Generated at: 2026-02-03T07:45:23.158Z
 * 
 * ⚠️  DO NOT EDIT MANUALLY
 * This file is regenerated on every build.
 * 
 * Discovered substances:
 * - 12 compounds
 * - 118 elements
 */

// ============================================================================
// COMPOUND LOADERS (lazy - loaded on demand)
// ============================================================================

export const compoundLoaders = {
  'acetic-acid': () => import('../data/substances/compounds/pure/acetic-acid-ch3cooh/info.json'),
  'acetone': () => import('../data/substances/compounds/pure/acetone-c3h6o/info.json'),
  'ammonia': () => import('../data/substances/compounds/pure/ammonia-nh3/info.json'),
  'ethanol': () => import('../data/substances/compounds/pure/ethanol-c2h5oh/info.json'),
  'glycerin': () => import('../data/substances/compounds/pure/glycerin-c3h8o3/info.json'),
  'hydrogen-peroxide': () => import('../data/substances/compounds/pure/hydrogen-peroxide-h2o2/info.json'),
  'isopropyl-alcohol': () => import('../data/substances/compounds/pure/isopropyl-alcohol-c3h8o/info.json'),
  'methane': () => import('../data/substances/compounds/pure/methane-ch4/info.json'),
  'propane': () => import('../data/substances/compounds/pure/propane-c3h8/info.json'),
  'sucrose': () => import('../data/substances/compounds/pure/sucrose-c12h22o11/info.json'),
  'water': () => import('../data/substances/compounds/pure/water-h2o/info.json'),
  'saltwater-3pct': () => import('../data/substances/compounds/solutions/saltwater-3pct-nacl/info.json')
}

// ============================================================================
// ELEMENT LOADERS (lazy - loaded on demand)
// ============================================================================

export const elementLoaders = {
  'H': () => import('../data/substances/periodic-table/001_H_nonmetal.json'),
  'He': () => import('../data/substances/periodic-table/002_He_noble-gas.json'),
  'Li': () => import('../data/substances/periodic-table/003_Li_alkali-metal.json'),
  'Be': () => import('../data/substances/periodic-table/004_Be_alkaline-earth-metal.json'),
  'B': () => import('../data/substances/periodic-table/005_B_metalloid.json'),
  'C': () => import('../data/substances/periodic-table/006_C_nonmetal.json'),
  'N': () => import('../data/substances/periodic-table/007_N_nonmetal.json'),
  'O': () => import('../data/substances/periodic-table/008_O_nonmetal.json'),
  'F': () => import('../data/substances/periodic-table/009_F_halogen.json'),
  'Ne': () => import('../data/substances/periodic-table/010_Ne_noble-gas.json'),
  'Na': () => import('../data/substances/periodic-table/011_Na_alkali-metal.json'),
  'Mg': () => import('../data/substances/periodic-table/012_Mg_alkaline-earth-metal.json'),
  'Al': () => import('../data/substances/periodic-table/013_Al_post-transition-metal.json'),
  'Si': () => import('../data/substances/periodic-table/014_Si_metalloid.json'),
  'P': () => import('../data/substances/periodic-table/015_P_nonmetal.json'),
  'S': () => import('../data/substances/periodic-table/016_S_nonmetal.json'),
  'Cl': () => import('../data/substances/periodic-table/017_Cl_halogen.json'),
  'Ar': () => import('../data/substances/periodic-table/018_Ar_noble-gas.json'),
  'K': () => import('../data/substances/periodic-table/019_K_alkali-metal.json'),
  'Ca': () => import('../data/substances/periodic-table/020_Ca_alkaline-earth-metal.json'),
  'Sc': () => import('../data/substances/periodic-table/021_Sc_transition-metal.json'),
  'Ti': () => import('../data/substances/periodic-table/022_Ti_transition-metal.json'),
  'V': () => import('../data/substances/periodic-table/023_V_transition-metal.json'),
  'Cr': () => import('../data/substances/periodic-table/024_Cr_transition-metal.json'),
  'Mn': () => import('../data/substances/periodic-table/025_Mn_transition-metal.json'),
  'Fe': () => import('../data/substances/periodic-table/026_Fe_transition-metal.json'),
  'Co': () => import('../data/substances/periodic-table/027_Co_transition-metal.json'),
  'Ni': () => import('../data/substances/periodic-table/028_Ni_transition-metal.json'),
  'Cu': () => import('../data/substances/periodic-table/029_Cu_transition-metal.json'),
  'Zn': () => import('../data/substances/periodic-table/030_Zn_transition-metal.json'),
  'Ga': () => import('../data/substances/periodic-table/031_Ga_post-transition-metal.json'),
  'Ge': () => import('../data/substances/periodic-table/032_Ge_metalloid.json'),
  'As': () => import('../data/substances/periodic-table/033_As_metalloid.json'),
  'Se': () => import('../data/substances/periodic-table/034_Se_nonmetal.json'),
  'Br': () => import('../data/substances/periodic-table/035_Br_halogen.json'),
  'Kr': () => import('../data/substances/periodic-table/036_Kr_noble-gas.json'),
  'Rb': () => import('../data/substances/periodic-table/037_Rb_alkali-metal.json'),
  'Sr': () => import('../data/substances/periodic-table/038_Sr_alkaline-earth-metal.json'),
  'Y': () => import('../data/substances/periodic-table/039_Y_transition-metal.json'),
  'Zr': () => import('../data/substances/periodic-table/040_Zr_transition-metal.json'),
  'Nb': () => import('../data/substances/periodic-table/041_Nb_transition-metal.json'),
  'Mo': () => import('../data/substances/periodic-table/042_Mo_transition-metal.json'),
  'Tc': () => import('../data/substances/periodic-table/043_Tc_transition-metal.json'),
  'Ru': () => import('../data/substances/periodic-table/044_Ru_transition-metal.json'),
  'Rh': () => import('../data/substances/periodic-table/045_Rh_transition-metal.json'),
  'Pd': () => import('../data/substances/periodic-table/046_Pd_transition-metal.json'),
  'Ag': () => import('../data/substances/periodic-table/047_Ag_transition-metal.json'),
  'Cd': () => import('../data/substances/periodic-table/048_Cd_transition-metal.json'),
  'In': () => import('../data/substances/periodic-table/049_In_post-transition-metal.json'),
  'Sn': () => import('../data/substances/periodic-table/050_Sn_post-transition-metal.json'),
  'Sb': () => import('../data/substances/periodic-table/051_Sb_metalloid.json'),
  'Te': () => import('../data/substances/periodic-table/052_Te_metalloid.json'),
  'I': () => import('../data/substances/periodic-table/053_I_halogen.json'),
  'Xe': () => import('../data/substances/periodic-table/054_Xe_noble-gas.json'),
  'Cs': () => import('../data/substances/periodic-table/055_Cs_alkali-metal.json'),
  'Ba': () => import('../data/substances/periodic-table/056_Ba_alkaline-earth-metal.json'),
  'La': () => import('../data/substances/periodic-table/057_La_lanthanide.json'),
  'Ce': () => import('../data/substances/periodic-table/058_Ce_lanthanide.json'),
  'Pr': () => import('../data/substances/periodic-table/059_Pr_lanthanide.json'),
  'Nd': () => import('../data/substances/periodic-table/060_Nd_lanthanide.json'),
  'Pm': () => import('../data/substances/periodic-table/061_Pm_lanthanide.json'),
  'Sm': () => import('../data/substances/periodic-table/062_Sm_lanthanide.json'),
  'Eu': () => import('../data/substances/periodic-table/063_Eu_lanthanide.json'),
  'Gd': () => import('../data/substances/periodic-table/064_Gd_lanthanide.json'),
  'Tb': () => import('../data/substances/periodic-table/065_Tb_lanthanide.json'),
  'Dy': () => import('../data/substances/periodic-table/066_Dy_lanthanide.json'),
  'Ho': () => import('../data/substances/periodic-table/067_Ho_lanthanide.json'),
  'Er': () => import('../data/substances/periodic-table/068_Er_lanthanide.json'),
  'Tm': () => import('../data/substances/periodic-table/069_Tm_lanthanide.json'),
  'Yb': () => import('../data/substances/periodic-table/070_Yb_lanthanide.json'),
  'Lu': () => import('../data/substances/periodic-table/071_Lu_lanthanide.json'),
  'Hf': () => import('../data/substances/periodic-table/072_Hf_transition-metal.json'),
  'Ta': () => import('../data/substances/periodic-table/073_Ta_transition-metal.json'),
  'W': () => import('../data/substances/periodic-table/074_W_transition-metal.json'),
  'Re': () => import('../data/substances/periodic-table/075_Re_transition-metal.json'),
  'Os': () => import('../data/substances/periodic-table/076_Os_transition-metal.json'),
  'Ir': () => import('../data/substances/periodic-table/077_Ir_transition-metal.json'),
  'Pt': () => import('../data/substances/periodic-table/078_Pt_transition-metal.json'),
  'Au': () => import('../data/substances/periodic-table/079_Au_transition-metal.json'),
  'Hg': () => import('../data/substances/periodic-table/080_Hg_transition-metal.json'),
  'Tl': () => import('../data/substances/periodic-table/081_Tl_post-transition-metal.json'),
  'Pb': () => import('../data/substances/periodic-table/082_Pb_post-transition-metal.json'),
  'Bi': () => import('../data/substances/periodic-table/083_Bi_post-transition-metal.json'),
  'Po': () => import('../data/substances/periodic-table/084_Po_metalloid.json'),
  'At': () => import('../data/substances/periodic-table/085_At_halogen.json'),
  'Rn': () => import('../data/substances/periodic-table/086_Rn_noble-gas.json'),
  'Fr': () => import('../data/substances/periodic-table/087_Fr_alkali-metal.json'),
  'Ra': () => import('../data/substances/periodic-table/088_Ra_alkaline-earth-metal.json'),
  'Ac': () => import('../data/substances/periodic-table/089_Ac_actinide.json'),
  'Th': () => import('../data/substances/periodic-table/090_Th_actinide.json'),
  'Pa': () => import('../data/substances/periodic-table/091_Pa_actinide.json'),
  'U': () => import('../data/substances/periodic-table/092_U_actinide.json'),
  'Np': () => import('../data/substances/periodic-table/093_Np_actinide.json'),
  'Pu': () => import('../data/substances/periodic-table/094_Pu_actinide.json'),
  'Am': () => import('../data/substances/periodic-table/095_Am_actinide.json'),
  'Cm': () => import('../data/substances/periodic-table/096_Cm_actinide.json'),
  'Bk': () => import('../data/substances/periodic-table/097_Bk_actinide.json'),
  'Cf': () => import('../data/substances/periodic-table/098_Cf_actinide.json'),
  'Es': () => import('../data/substances/periodic-table/099_Es_actinide.json'),
  'Fm': () => import('../data/substances/periodic-table/100_Fm_actinide.json'),
  'Md': () => import('../data/substances/periodic-table/101_Md_actinide.json'),
  'No': () => import('../data/substances/periodic-table/102_No_actinide.json'),
  'Lr': () => import('../data/substances/periodic-table/103_Lr_actinide.json'),
  'Rf': () => import('../data/substances/periodic-table/104_Rf_transition-metal.json'),
  'Db': () => import('../data/substances/periodic-table/105_Db_transition-metal.json'),
  'Sg': () => import('../data/substances/periodic-table/106_Sg_transition-metal.json'),
  'Bh': () => import('../data/substances/periodic-table/107_Bh_transition-metal.json'),
  'Hs': () => import('../data/substances/periodic-table/108_Hs_transition-metal.json'),
  'Mt': () => import('../data/substances/periodic-table/109_Mt_transition-metal.json'),
  'Ds': () => import('../data/substances/periodic-table/110_Ds_transition-metal.json'),
  'Rg': () => import('../data/substances/periodic-table/111_Rg_transition-metal.json'),
  'Cn': () => import('../data/substances/periodic-table/112_Cn_transition-metal.json'),
  'Nh': () => import('../data/substances/periodic-table/113_Nh_post-transition-metal.json'),
  'Fl': () => import('../data/substances/periodic-table/114_Fl_post-transition-metal.json'),
  'Mc': () => import('../data/substances/periodic-table/115_Mc_post-transition-metal.json'),
  'Lv': () => import('../data/substances/periodic-table/116_Lv_post-transition-metal.json'),
  'Ts': () => import('../data/substances/periodic-table/117_Ts_halogen.json'),
  'Og': () => import('../data/substances/periodic-table/118_Og_noble-gas.json')
}

// ============================================================================
// METADATA (for UI dropdowns and display names)
// ============================================================================

export const compoundMetadata = {
  'acetic-acid': { displayName: 'Acetic Acid', category: 'compound', folderPath: 'pure/acetic-acid-ch3cooh' },
  'acetone': { displayName: 'Acetone', category: 'compound', folderPath: 'pure/acetone-c3h6o' },
  'ammonia': { displayName: 'Ammonia', category: 'compound', folderPath: 'pure/ammonia-nh3' },
  'ethanol': { displayName: 'Ethanol', category: 'compound', folderPath: 'pure/ethanol-c2h5oh' },
  'glycerin': { displayName: 'Glycerin', category: 'compound', folderPath: 'pure/glycerin-c3h8o3' },
  'hydrogen-peroxide': { displayName: 'Hydrogen Peroxide', category: 'compound', folderPath: 'pure/hydrogen-peroxide-h2o2' },
  'isopropyl-alcohol': { displayName: 'Isopropyl Alcohol', category: 'compound', folderPath: 'pure/isopropyl-alcohol-c3h8o' },
  'methane': { displayName: 'Methane', category: 'compound', folderPath: 'pure/methane-ch4' },
  'propane': { displayName: 'Propane', category: 'compound', folderPath: 'pure/propane-c3h8' },
  'sucrose': { displayName: 'Sucrose', category: 'compound', folderPath: 'pure/sucrose-c12h22o11' },
  'water': { displayName: 'Water', category: 'compound', folderPath: 'pure/water-h2o' },
  'saltwater-3pct': { displayName: 'Saltwater (3% NaCl by mass)', category: 'compound', folderPath: 'solutions/saltwater-3pct-nacl' }
}

export const elementMetadata = {
  'H': { displayName: 'Hydrogen', category: 'element', atomicNumber: 1 },
  'He': { displayName: 'Helium', category: 'element', atomicNumber: 2 },
  'Li': { displayName: 'Lithium', category: 'element', atomicNumber: 3 },
  'Be': { displayName: 'Beryllium', category: 'element', atomicNumber: 4 },
  'B': { displayName: 'Boron', category: 'element', atomicNumber: 5 },
  'C': { displayName: 'Carbon', category: 'element', atomicNumber: 6 },
  'N': { displayName: 'Nitrogen', category: 'element', atomicNumber: 7 },
  'O': { displayName: 'Oxygen', category: 'element', atomicNumber: 8 },
  'F': { displayName: 'Fluorine', category: 'element', atomicNumber: 9 },
  'Ne': { displayName: 'Neon', category: 'element', atomicNumber: 10 },
  'Na': { displayName: 'Sodium', category: 'element', atomicNumber: 11 },
  'Mg': { displayName: 'Magnesium', category: 'element', atomicNumber: 12 },
  'Al': { displayName: 'Aluminum', category: 'element', atomicNumber: 13 },
  'Si': { displayName: 'Silicon', category: 'element', atomicNumber: 14 },
  'P': { displayName: 'Phosphorus', category: 'element', atomicNumber: 15 },
  'S': { displayName: 'Sulfur', category: 'element', atomicNumber: 16 },
  'Cl': { displayName: 'Chlorine', category: 'element', atomicNumber: 17 },
  'Ar': { displayName: 'Argon', category: 'element', atomicNumber: 18 },
  'K': { displayName: 'Potassium', category: 'element', atomicNumber: 19 },
  'Ca': { displayName: 'Calcium', category: 'element', atomicNumber: 20 },
  'Sc': { displayName: 'Scandium', category: 'element', atomicNumber: 21 },
  'Ti': { displayName: 'Titanium', category: 'element', atomicNumber: 22 },
  'V': { displayName: 'Vanadium', category: 'element', atomicNumber: 23 },
  'Cr': { displayName: 'Chromium', category: 'element', atomicNumber: 24 },
  'Mn': { displayName: 'Manganese', category: 'element', atomicNumber: 25 },
  'Fe': { displayName: 'Iron', category: 'element', atomicNumber: 26 },
  'Co': { displayName: 'Cobalt', category: 'element', atomicNumber: 27 },
  'Ni': { displayName: 'Nickel', category: 'element', atomicNumber: 28 },
  'Cu': { displayName: 'Copper', category: 'element', atomicNumber: 29 },
  'Zn': { displayName: 'Zinc', category: 'element', atomicNumber: 30 },
  'Ga': { displayName: 'Gallium', category: 'element', atomicNumber: 31 },
  'Ge': { displayName: 'Germanium', category: 'element', atomicNumber: 32 },
  'As': { displayName: 'Arsenic', category: 'element', atomicNumber: 33 },
  'Se': { displayName: 'Selenium', category: 'element', atomicNumber: 34 },
  'Br': { displayName: 'Bromine', category: 'element', atomicNumber: 35 },
  'Kr': { displayName: 'Krypton', category: 'element', atomicNumber: 36 },
  'Rb': { displayName: 'Rubidium', category: 'element', atomicNumber: 37 },
  'Sr': { displayName: 'Strontium', category: 'element', atomicNumber: 38 },
  'Y': { displayName: 'Yttrium', category: 'element', atomicNumber: 39 },
  'Zr': { displayName: 'Zirconium', category: 'element', atomicNumber: 40 },
  'Nb': { displayName: 'Niobium', category: 'element', atomicNumber: 41 },
  'Mo': { displayName: 'Molybdenum', category: 'element', atomicNumber: 42 },
  'Tc': { displayName: 'Technetium', category: 'element', atomicNumber: 43 },
  'Ru': { displayName: 'Ruthenium', category: 'element', atomicNumber: 44 },
  'Rh': { displayName: 'Rhodium', category: 'element', atomicNumber: 45 },
  'Pd': { displayName: 'Palladium', category: 'element', atomicNumber: 46 },
  'Ag': { displayName: 'Silver', category: 'element', atomicNumber: 47 },
  'Cd': { displayName: 'Cadmium', category: 'element', atomicNumber: 48 },
  'In': { displayName: 'Indium', category: 'element', atomicNumber: 49 },
  'Sn': { displayName: 'Tin', category: 'element', atomicNumber: 50 },
  'Sb': { displayName: 'Antimony', category: 'element', atomicNumber: 51 },
  'Te': { displayName: 'Tellurium', category: 'element', atomicNumber: 52 },
  'I': { displayName: 'Iodine', category: 'element', atomicNumber: 53 },
  'Xe': { displayName: 'Xenon', category: 'element', atomicNumber: 54 },
  'Cs': { displayName: 'Cesium', category: 'element', atomicNumber: 55 },
  'Ba': { displayName: 'Barium', category: 'element', atomicNumber: 56 },
  'La': { displayName: 'Lanthanum', category: 'element', atomicNumber: 57 },
  'Ce': { displayName: 'Cerium', category: 'element', atomicNumber: 58 },
  'Pr': { displayName: 'Praseodymium', category: 'element', atomicNumber: 59 },
  'Nd': { displayName: 'Neodymium', category: 'element', atomicNumber: 60 },
  'Pm': { displayName: 'Promethium', category: 'element', atomicNumber: 61 },
  'Sm': { displayName: 'Samarium', category: 'element', atomicNumber: 62 },
  'Eu': { displayName: 'Europium', category: 'element', atomicNumber: 63 },
  'Gd': { displayName: 'Gadolinium', category: 'element', atomicNumber: 64 },
  'Tb': { displayName: 'Terbium', category: 'element', atomicNumber: 65 },
  'Dy': { displayName: 'Dysprosium', category: 'element', atomicNumber: 66 },
  'Ho': { displayName: 'Holmium', category: 'element', atomicNumber: 67 },
  'Er': { displayName: 'Erbium', category: 'element', atomicNumber: 68 },
  'Tm': { displayName: 'Thulium', category: 'element', atomicNumber: 69 },
  'Yb': { displayName: 'Ytterbium', category: 'element', atomicNumber: 70 },
  'Lu': { displayName: 'Lutetium', category: 'element', atomicNumber: 71 },
  'Hf': { displayName: 'Hafnium', category: 'element', atomicNumber: 72 },
  'Ta': { displayName: 'Tantalum', category: 'element', atomicNumber: 73 },
  'W': { displayName: 'Tungsten', category: 'element', atomicNumber: 74 },
  'Re': { displayName: 'Rhenium', category: 'element', atomicNumber: 75 },
  'Os': { displayName: 'Osmium', category: 'element', atomicNumber: 76 },
  'Ir': { displayName: 'Iridium', category: 'element', atomicNumber: 77 },
  'Pt': { displayName: 'Platinum', category: 'element', atomicNumber: 78 },
  'Au': { displayName: 'Gold', category: 'element', atomicNumber: 79 },
  'Hg': { displayName: 'Mercury', category: 'element', atomicNumber: 80 },
  'Tl': { displayName: 'Thallium', category: 'element', atomicNumber: 81 },
  'Pb': { displayName: 'Lead', category: 'element', atomicNumber: 82 },
  'Bi': { displayName: 'Bismuth', category: 'element', atomicNumber: 83 },
  'Po': { displayName: 'Polonium', category: 'element', atomicNumber: 84 },
  'At': { displayName: 'Astatine', category: 'element', atomicNumber: 85 },
  'Rn': { displayName: 'Radon', category: 'element', atomicNumber: 86 },
  'Fr': { displayName: 'Francium', category: 'element', atomicNumber: 87 },
  'Ra': { displayName: 'Radium', category: 'element', atomicNumber: 88 },
  'Ac': { displayName: 'Actinium', category: 'element', atomicNumber: 89 },
  'Th': { displayName: 'Thorium', category: 'element', atomicNumber: 90 },
  'Pa': { displayName: 'Protactinium', category: 'element', atomicNumber: 91 },
  'U': { displayName: 'Uranium', category: 'element', atomicNumber: 92 },
  'Np': { displayName: 'Neptunium', category: 'element', atomicNumber: 93 },
  'Pu': { displayName: 'Plutonium', category: 'element', atomicNumber: 94 },
  'Am': { displayName: 'Americium', category: 'element', atomicNumber: 95 },
  'Cm': { displayName: 'Curium', category: 'element', atomicNumber: 96 },
  'Bk': { displayName: 'Berkelium', category: 'element', atomicNumber: 97 },
  'Cf': { displayName: 'Californium', category: 'element', atomicNumber: 98 },
  'Es': { displayName: 'Einsteinium', category: 'element', atomicNumber: 99 },
  'Fm': { displayName: 'Fermium', category: 'element', atomicNumber: 100 },
  'Md': { displayName: 'Mendelevium', category: 'element', atomicNumber: 101 },
  'No': { displayName: 'Nobelium', category: 'element', atomicNumber: 102 },
  'Lr': { displayName: 'Lawrencium', category: 'element', atomicNumber: 103 },
  'Rf': { displayName: 'Rutherfordium', category: 'element', atomicNumber: 104 },
  'Db': { displayName: 'Dubnium', category: 'element', atomicNumber: 105 },
  'Sg': { displayName: 'Seaborgium', category: 'element', atomicNumber: 106 },
  'Bh': { displayName: 'Bohrium', category: 'element', atomicNumber: 107 },
  'Hs': { displayName: 'Hassium', category: 'element', atomicNumber: 108 },
  'Mt': { displayName: 'Meitnerium', category: 'element', atomicNumber: 109 },
  'Ds': { displayName: 'Darmstadtium', category: 'element', atomicNumber: 110 },
  'Rg': { displayName: 'Roentgenium', category: 'element', atomicNumber: 111 },
  'Cn': { displayName: 'Copernicium', category: 'element', atomicNumber: 112 },
  'Nh': { displayName: 'Nihonium', category: 'element', atomicNumber: 113 },
  'Fl': { displayName: 'Flerovium', category: 'element', atomicNumber: 114 },
  'Mc': { displayName: 'Moscovium', category: 'element', atomicNumber: 115 },
  'Lv': { displayName: 'Livermorium', category: 'element', atomicNumber: 116 },
  'Ts': { displayName: 'Tennessine', category: 'element', atomicNumber: 117 },
  'Og': { displayName: 'Oganesson', category: 'element', atomicNumber: 118 }
}

// ============================================================================
// DISCOVERY FUNCTIONS
// ============================================================================

/**
 * Get all available compound IDs
 */
export function getAvailableCompounds() {
  return Object.keys(compoundLoaders)
}

/**
 * Get all available element symbols
 */
export function getAvailableElements() {
  return Object.keys(elementLoaders)
}

/**
 * Get all available substance IDs (compounds + elements)
 */
export function getAvailableSubstances() {
  return [...getAvailableCompounds(), ...getAvailableElements()]
}
